import {QueryClient, QueryClientConfig} from '@tanstack/react-query';
import deepmerge from 'deepmerge';
import {IS_CLIENT_SIDE} from '../common/shared/utils/constants';
import {MUTATION_DEFAULT_OPTION, QUERY_DEFAULT_OPTION} from './constant';

const QueryClientForCSR = IS_CLIENT_SIDE ? new QueryClient() : undefined;

export function createQueryClient(config?: QueryClientConfig) {
  // JEST 독립적으로 react-query 에서 제안하는 클라이언트를 사용하기 위해 별도로 생성해줍니다. 참고 : https://tanstack.com/query/v4/docs/react/guides/testing#turn-off-retries
  if (process?.env?.JEST_WORKER_ID) {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
          gcTime: Infinity,
        },
      },
    });
  }
  const mergedConfig = deepmerge(
    {
      defaultOptions: {
        queries: QUERY_DEFAULT_OPTION,
        mutations: MUTATION_DEFAULT_OPTION,
      },
    } as QueryClientConfig,
    config || {}
  );
  if (IS_CLIENT_SIDE) {
    QueryClientForCSR?.setDefaultOptions({
      queries: mergedConfig?.defaultOptions?.queries,
      mutations: mergedConfig?.defaultOptions?.mutations,
    });
  }
  return IS_CLIENT_SIDE
    ? (QueryClientForCSR as QueryClient)
    : new QueryClient(mergedConfig);
}
